import { render, staticRenderFns } from "./Downloadresult.vue?vue&type=template&id=ca861262"
import script from "./Downloadresult.vue?vue&type=script&lang=js"
export * from "./Downloadresult.vue?vue&type=script&lang=js"
import style0 from "./Downloadresult.vue?vue&type=style&index=0&id=ca861262&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports